import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=04257ecb&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=04257ecb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04257ecb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04257ecb')) {
      api.createRecord('04257ecb', component.options)
    } else {
      api.reload('04257ecb', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=04257ecb&scoped=true&", function () {
      api.rerender('04257ecb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Mo2X9fRQS6NY/JS/comp/SearchFilterTokens.vue"
export default component.exports